import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/RyanCuddy/subs.vtt';
import poster from '@/static/assets/reviews/RyanCuddy/video.jpg';

export const RyanCuddy: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Home],
  reviewerName: 'Ryan',
  videoUrl: `${ASSETS_URL}/home/RyanCuddy_Home.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
